(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["houghton-booking-modal"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    var modal = document.getElementById('houghton-booking-modal');
    if (!modal || modal.dataset.bound) return;
    modal.dataset.bound = '1';

    var dialog = modal.querySelector('.hbm__dialog');
    var scroller = modal.querySelector('[data-hbm-scroll]');
    var lastFocused = null;

    function syncScrollState() {
      modal.classList.toggle('is-scrolled', scroller.scrollTop > 4);
    }

    function open() {
      lastFocused = document.activeElement;
      modal.classList.add('is-open');
      modal.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      if (scroller) {
        scroller.scrollTop = 0;
        syncScrollState();
      }
      if (dialog) dialog.focus({ preventScroll: true });
    }
    function close() {
      modal.classList.remove('is-open', 'is-scrolled');
      modal.setAttribute('hidden', '');
      document.body.style.overflow = '';
      // reset any loading buttons
      modal.querySelectorAll('.hbm__book.is-loading').forEach(function (b) {
        b.classList.remove('is-loading');
      });
      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus({ preventScroll: true });
      }
      lastFocused = null;
    }

    if (scroller) scroller.addEventListener('scroll', syncScrollState, { passive: true });

    // Expose a global opener for the Book Appointment triggers.
    window.HoughtonOpenBooking = open;

    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-hbm-close]')) { close(); return; }

      var bookBtn = e.target.closest('.hbm__book');
      if (bookBtn) {
        var handle = bookBtn.getAttribute('data-appt-handle');
        if (!handle) return;
        bookBtn.classList.add('is-loading');

        // Appointo may load its trigger late; retry briefly before falling back.
        var tries = 0;
        (function attempt() {
          if (typeof window.InitFromPandaBot === 'function') {
            try {
              window.InitFromPandaBot(handle);
            } catch (err) {
              console.error('[Houghton] InitFromPandaBot threw', err);
            }
            setTimeout(close, 1200);
            return;
          }
          if (++tries > 20) {
            console.warn('[Houghton] InitFromPandaBot unavailable — opening product page', handle);
            window.location.href = '/products/' + handle;
            return;
          }
          setTimeout(attempt, 120);
        })();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["houghton-gallery-quote"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSection(root) {
    if (!root || root.dataset.gqBound) return;
    root.dataset.gqBound = '1';
    var track = root.querySelector('.gq__track');
    var cells = root.querySelectorAll('.gq__cell');
    var dots = root.querySelectorAll('.gq__dot');
    var quotes = root.querySelectorAll('.gq__quote');
    if (!track || !cells.length) return;

    function setActive(pair) {
      dots.forEach(function (d) { d.classList.toggle('is-active', d.dataset.pair === pair); });
      quotes.forEach(function (q) { q.classList.toggle('is-active', q.dataset.pair === pair); });
    }

    // As the gallery scrolls, sync the quote to the pairing currently in view.
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) setActive(e.target.dataset.pair);
        });
      }, { root: track, threshold: 0.6 });
      cells.forEach(function (c) { io.observe(c); });
    }

    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        var pair = d.dataset.pair;
        var target = root.querySelector('.gq__cell[data-pair="' + pair + '"]');
        if (!target) return;

        // Desktop: crossfade transition instead of smooth scroll.
        if (window.matchMedia('(min-width: 750px)').matches) {
          track.classList.add('is-fading');
          setTimeout(function () {
            track.scrollLeft = target.offsetLeft;
            setActive(pair);
            setTimeout(function () { track.classList.remove('is-fading'); }, 50);
          }, 400);
        } else {
          target.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
          setActive(pair);
        }
      });
    });

    setActive('0');
  }
  function initAll(scope) {
    (scope || document).querySelectorAll('.gq').forEach(initSection);
  }
  if (document.readyState !== 'loading') { initAll(); }
  else { document.addEventListener('DOMContentLoaded', function () { initAll(); }); }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["houghton-how-it-works"] && !Shopify.designMode) return;
  try {
    
(function () {
  var MOBILE = '(max-width: 749px)';

  // Inactive panes are display:none, and a hidden lazy image never starts
  // downloading — so switching tabs used to wait on a cold request. Promote
  // the hidden images to eager once the section is near the viewport; eager
  // images fetch normally even inside a hidden subtree.
  // Only the set the current breakpoint shows is warmed: desktop renders the
  // .hiw__pane row, mobile renders the image inside each tab.
  function warmImages(root) {
    var selector = window.matchMedia(MOBILE).matches ? '.hiw__tabimg' : '.hiw__pane';
    root.querySelectorAll(selector + ' img[loading="lazy"]').forEach(function (img) {
      img.loading = 'eager';
    });
  }

  function warmWhenNear(root) {
    if (!('IntersectionObserver' in window)) {
      warmImages(root);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      if (!entries.some(function (e) { return e.isIntersecting; })) return;
      io.disconnect();
      warmImages(root);
      // Crossing the breakpoint later swaps in the other set of images.
      var mq = window.matchMedia(MOBILE);
      var onChange = function () { warmImages(root); };
      if (mq.addEventListener) mq.addEventListener('change', onChange);
      else if (mq.addListener) mq.addListener(onChange);
    }, { rootMargin: '600px 0px' });
    io.observe(root);
  }

  function initSection(root) {
    if (!root || root.dataset.hiwBound) return;
    root.dataset.hiwBound = '1';
    warmWhenNear(root);
    var tabs = root.querySelectorAll('.hiw__tab');
    var panes = root.querySelectorAll('.hiw__pane');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var i = tab.getAttribute('data-i');
        tabs.forEach(function (t) {
          var on = t.getAttribute('data-i') === i;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panes.forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-i') === i);
        });
      });
    });
  }
  function initAll(scope) {
    (scope || document).querySelectorAll('.hiw').forEach(initSection);
  }
  if (document.readyState !== 'loading') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  }
  // Theme editor: re-bind when this section is re-rendered.
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["houghton-press-quote"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    var track = root.querySelector('[data-pq-track]');
    if (!track || track.dataset.pqBound) return;
    track.dataset.pqBound = '1';
    var slides = root.querySelectorAll('[data-pq-slide]');
    var dots = root.querySelectorAll('[data-pq-dot]');
    var prev = root.querySelector('[data-pq-prev]');
    var next = root.querySelector('[data-pq-next]');
    if (slides.length < 2) return;

    function current() { return Math.round(track.scrollLeft / track.clientWidth); }
    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    }
    function sync() {
      var i = current();
      for (var d = 0; d < dots.length; d++) {
        dots[d].setAttribute('aria-current', d === i ? 'true' : 'false');
      }
    }
    for (var k = 0; k < dots.length; k++) {
      (function (idx) { dots[idx].addEventListener('click', function () { go(idx); }); })(k);
    }
    if (prev) prev.addEventListener('click', function () { go(current() - 1); });
    if (next) next.addEventListener('click', function () { go(current() + 1); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    sync();
  }
  function initAll(scope) { (scope || document).querySelectorAll('.pquote').forEach(init); }
  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["houghton-size-guide"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    var modal = document.getElementById('size-guide-modal');
    if (!modal || modal.dataset.bound) return;
    modal.dataset.bound = '1';

    function open(e) { if (e) e.preventDefault(); modal.classList.add('is-open'); modal.removeAttribute('hidden'); document.body.style.overflow = 'hidden'; }
    function close() { modal.classList.remove('is-open'); document.body.style.overflow = ''; }

    // any "Size Guide" link points at #size-guide-modal
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('a[href$="#size-guide-modal"], [data-size-guide-open]');
      if (trigger) { open(e); return; }
      if (e.target.closest('[data-szg-close]')) { close(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    var addBtn = modal.querySelector('[data-szg-add]');
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var variantId = addBtn.dataset.variantId;
        if (!variantId) return;
        addBtn.disabled = true;
        var drawer = document.querySelector('cart-drawer-component');
        var sectionId = drawer ? (drawer.querySelector('[data-section-id]') || {}).dataset && drawer.querySelector('[data-section-id]').dataset.sectionId : null;
        var body = { items: [{ id: variantId, quantity: 1 }] };
        if (sectionId) body.sections = sectionId;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
          body: JSON.stringify(body)
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: { resource: data, sourceId: 'size-guide', data: { source: 'size-guide', sections: data.sections } }
            }));
            close();
            if (drawer && typeof drawer.open === 'function') drawer.open();
          })
          .catch(function () {})
          .finally(function () { addBtn.disabled = false; });
      });
    }
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
